export default __webpack_public_path__ + "static/media/band.bd99b068.svg";